// `voice.profile`: a voice Kling 4.0 speaks with, made from a clip of one speaker (spec
// G2-kling-v4-voices). The composer's voices start it (its PR 4); a Studio draft never holds one.
import { VoiceProfileQuote, VoiceProfileRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"voice.profile"> = {
  type: "voice.profile",
  label: "Voice profile",
  source: "form",
  pair: "voice.profile",
  fields: () => ({}),
  request: VoiceProfileRequest,
  quote: VoiceProfileQuote,
};
